export default {
  activity: {
    include_activity_owner: true,
    include_activity_owner_image: true,
  },
  comment: {
    include_comment_user: true,
  },
  conversation: {
    include_conversation_comments: true,
    include_conversation_subscribers: true,
  },
  image: {
    include_image_sizes: true,
  },
  subscriber: {
    include_subscriber_user: true,
  },
  user: {
    include_user_image: true,
  },
}
